import React, { useState, useCallback } from 'react'
import { Button, Modal, Toast } from '@ow/comps'
import { pick } from 'lodash-es'
import { Radio } from '@mantine/core'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { exportStatisticExcel } from '@vt/apis/lib-ex/v2/givrali'

const Exporter = function ({ children }) {
  const { appId } = useAppEx()
  const [isDisable, setIsDisable] = useState(false)
  const [type, setType] = useState('all')
  const [standard, setStandardOpt] = useState('all')
  const {
    tbId,
    exporterStatisticsConfig,
    filters,
    selectedIds,
    defaultFilters,
  } = useTbViewStore((state) =>
    pick(state, [
      'tbId',
      'exporterStatisticsConfig',
      'filters',
      'selectedIds',
      'defaultFilters',
    ])
  )

  const options = []
  if (exporterStatisticsConfig && exporterStatisticsConfig.exporterAll) {
    options.push({ label: '导出全部', value: 'all', defaultChecked: true })
  }
  if (exporterStatisticsConfig && exporterStatisticsConfig.exporterFilters) {
    options.push({
      label: '导出筛选条件下的数据',
      value: 'filters',
    })
  }
  if (
    exporterStatisticsConfig &&
    exporterStatisticsConfig.exporterChecked &&
    selectedIds.length
  ) {
    options.push({
      label: '导出选中的数据',
      value: 'checked',
      disabled: !selectedIds.length,
    })
  }
  const standardOpt = [
    {
      label: '全部指标',
      value: 'all',
    },
    {
      label: '导出案件相关指标',
      value: 'ucase',
    },
  ]
  const exportStatistic = (fil, exportType) => {
    exportStatisticExcel(appId, tbId, standard === 'all', fil, exportType)
      .then((res) => {
        setIsDisable(false)
        window.open(res.ossUrl)
      })
      .catch(() => {
        setIsDisable(false)
        Toast.error({
          title: '案件数不能超过10000条，请重新选择',
        })
      })
  }
  const exportAllFn = () => {
    const childQueries = []
    selectedIds.map((item) => {
      childQueries.push(
        {
          queryType: 'just',
          yacQueryOperate: {
            operator: 'equal',
            left: {
              slug: 'objectId',
            },
            right: {
              value: item,
            },
          },
        },
        {
          queryType: 'not',
          yacQueryOperate: {
            operator: 'equal',
            left: {
              slug: 'isFakeDeleted',
            },
            right: {
              value: true,
            },
          },
        }
      )
      return selectedIds
    })

    const checkedData = {
      queryType: 'and',
      childQueries: [
        {
          queryType: 'or',
          childQueries,
        },
      ],
    }
    if (type === 'all') {
      // 导出全部
      setIsDisable(true)
      exportStatistic(
        {
          logicType: 'and',
          queries: [
            ...defaultFilters.queries,
            {
              slug: 'isFakeDeleted',
              value: true,
              queryType: ['notEqual'],
            },
          ],
        },
        'all'
      )
    } else if (type === 'checked') {
      // 导出选中
      setIsDisable(true)
      exportStatistic({ ...checkedData, size: 50, page: 0 }, 'checked')
    } else {
      // 导出筛选条件
      setIsDisable(true)
      exportStatistic(filters, 'all')
    }
  }

  const FooterComp = useCallback(
    ({ close }) => (
      <div className="flex">
        <Button
          className="mr-2"
          type="secondary"
          opacityType="sm"
          onClick={() => {
            close()
          }}
        >
          取消
        </Button>
        <Button
          className="mr-2"
          type="primary"
          disabled={isDisable}
          onClick={() => {
            exportAllFn()
            close()
          }}
        >
          导出
        </Button>
      </div>
    ),
    [type, isDisable, filters, standard]
  )
  return (
    <Modal
      nested
      size="sm"
      title="导出"
      trigger={children}
      showCloseButton
      footer={FooterComp}
    >
      <>
        <Radio.Group
          orientation="vertical"
          label="请选择导出内容："
          value={type}
          onChange={setType}
        >
          {options.map((v) => {
            return <Radio value={v.value} label={v.label} />
          })}
        </Radio.Group>
        <Radio.Group
          orientation="vertical"
          label="请选择指标导出内容："
          value={standard}
          style={{ marginTop: '20px' }}
          onChange={setStandardOpt}
        >
          {standardOpt.map((v) => {
            return <Radio value={v.value} label={v.label} />
          })}
        </Radio.Group>
      </>
    </Modal>
  )
}

export default Exporter
